<div id="report">

    <h2>Crear Informe</h2>

    <div id="report-course" class="mt-3">
        <p><b>Curso seleccionado:</b> {{ name }}</p>
    </div>

    <div id="report-info" class="mt-3">
        <!-- <p>Report Type: {{ type }}</p> -->
        <p><b>Tipo de informe:</b> {{ typeStr }}</p>
    </div>
    
    <div id="report-writer" class="mt-3">
        <p class="fw-bold">Formato del informe:</p>
        <label for="writer-html" class="d-block">
            <input type="radio" name="writer" id="writer-html" [(ngModel)]="writer" [value]="'html'">
            <span class="ms-2">HTML</span>
        </label>
        <label for="writer-txt" class="d-block">
            <input type="radio" name="writer" id="writer-txt" [(ngModel)]="writer" [value]="'txt'">
            <span class="ms-2">TXT</span>
        </label>
        <label for="writer-csv" class="d-block">
            <input type="radio" name="writer" id="writer-csv" [(ngModel)]="writer" [value]="'csv'">
            <span class="ms-2">CSV</span>
        </label>
        <label for="writer-json" class="d-block">
            <input type="radio" name="writer" id="writer-json" [(ngModel)]="writer" [value]="'json'">
            <span class="ms-2">JSON</span>
        </label>
    </div>

    <div id="report-buttons" class="mt-3">
        <button class="btn btn-success me-3" (click)="generate()" [attr.disabled]="generating ? 'disabled' : null">
            <i class="fa fa-copy"></i>
            <span>Generar informe</span>
        </button>
        <button class="btn btn-danger me-3" (click)="close()">
            <i class="fa fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

    <div id="report-status" class="mt-3" *ngIf="generating || generateError || generateSuccess">
        <div id="report-generating" *ngIf="generating">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Generando informe...</span>
        </div>
        <div id="report-generate-error" class="text-danger" *ngIf="generateError">
            <i class="fa fa-times"></i>
            <span>Ha habido un error. Por favor, inténtalo de nuevo.</span>
        </div>
        <div id="report-generate-success" class="text-success" *ngIf="generateSuccess">
            <i class="fa fa-check"></i>
            <span>Informe generado correctamente.</span>
        </div>
    </div>

    <div id="report-link" class="mt-3" *ngIf="generateSuccess">
        <a href="{{ reportLink }}" target="_blank">Ver informe</a>
    </div>
</div>